var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "position-relative",
      class: _vm.isMobile ? "text-center" : "",
    },
    [
      _vm.isMobile
        ? _c("SelectFileSizeDropdown", {
            attrs: {
              "is-day-billing-selected": _vm.isDayBillingSelected,
              "selectable-sizes": _vm.selectableSizes,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "labelText",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("trans")("Total file size per conversion")
                          ) +
                          "\n            "
                      ),
                      _c("Tooltip", {
                        attrs: { position: "bottom" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-question-circle text-info cursor-pointer",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "tooltip-content",
                              fn: function () {
                                return [_vm._v(" " + _vm._s(_vm.tooltipText))]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1255689689
                        ),
                      }),
                      _vm._v(":\n            "),
                      _c("br"),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2426672818
            ),
            model: {
              value: _vm.selectedSize,
              callback: function ($$v) {
                _vm.selectedSize = $$v
              },
              expression: "selectedSize",
            },
          })
        : !_vm.isMobile
        ? _c("SelectFileSizeSlider", {
            attrs: {
              "is-day-billing-selected": _vm.isDayBillingSelected,
              "selectable-sizes": _vm.selectableSizes,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u([
              {
                key: "labelText",
                fn: function () {
                  return [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("trans")("Total file size per conversion")
                        ) +
                        "\n            "
                    ),
                    _c("Tooltip", {
                      attrs: { position: "bottom" },
                      scopedSlots: _vm._u([
                        {
                          key: "icon",
                          fn: function () {
                            return [
                              _c("i", {
                                staticClass:
                                  "fa fa-question-circle text-info cursor-pointer",
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "tooltip-content",
                          fn: function () {
                            return [_vm._v(" " + _vm._s(_vm.tooltipText))]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _vm._v(":\n        "),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.selectedSize,
              callback: function ($$v) {
                _vm.selectedSize = $$v
              },
              expression: "selectedSize",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }